import { isNotNil, parseURL } from './../../utils';

/*
 * Makes sure our path ends with a proper trailing slash
 */
function _ensureTrailingSlash(aUrl: string): string {
  return aUrl.endsWith('/') ? aUrl : aUrl + '/';
}

const decode = decodeURIComponent;

function _createBaseURL(aUrl: URL | string): string {
  const url = parseURL(aUrl);
  return isNotNil(url)
    ? _ensureTrailingSlash(`${url.origin}${url.pathname}`)
    : undefined;
}

export { _createBaseURL as createBaseURL };
